const i18nTexts = {
    'pt-BR': {
        About_Header: 'Sobre',
        Project_Header: 'Projetos',
        Contact_Header: 'Contatos',

        TextProfession_Intro: 'UNITY DEVELOPER · UX DESIGN',
        TextPresentation_Intro: 'Olá! Eu sou a Marielle Fidelis',
       TextProfile_Intro: 'Sou Unity Developer com mais de 4 anos de experiência criando jogos e experiências interativas para PC, mobile e web. Trabalho do protótipo à entrega final, combinando desenvolvimento, UX Design e polimento para criar interações mais claras, responsivas e agradáveis.',
        TextProfile_Intro_Extra: 'Atualmente trabalho como Unity Developer Pleno e curso Pós-Graduação em UX Engineering. Quer ver mais detalhes? Dá uma olhada no meu currículo.',
        TextButtonCurriculum_Intro: 'Currículo',

        Section_Project: 'Projetos',
       Description_Hooked_Project: 'Responsável por:\n• Design e implementação de UI/UX\n• Wireframes e protótipos\n• Animações de UI e feedbacks visuais\n• Documentação do projeto',
        Description_Legaldigital_Project: 'Responsável por:\n• Desenvolvimento completo de gameplay\n• Criação de minigames e lógica de tabuleiro\n• Implementação de arte\n• Testes, polimento e build para publicação',
       Description_Blockar_Project: 'Responsável por:\n• Design e implementação de UI/UX\n• Wireframes e protótipos\n• Game feel e feedbacks visuais\n• VFX e polimento\n• Documentação do sistema',
        Button_View_Project: 'Ver Mais',

        Section_About: 'Sobre Mim',
        TextProfile_01_About: 'Sou formada em Jogos Digitais pela PUC Minas e atualmente curso Pós-Graduação em UX Engineering. Ao longo de mais de 4 anos de experiência, participei de mais de 30 projetos para mobile, PC e web, atuando em diferentes etapas do desenvolvimento, da prototipagem ao polimento final. Meu trabalho une Unity, UX Design e cuidado com a experiência do usuário. Gosto de pensar nos detalhes que tornam uma interação mais clara e agradável, como feedbacks visuais, responsividade, usabilidade, game feel e consistência. Também tenho experiência com Game Design, Figma e desenvolvimento web com HTML, CSS e JavaScript.',
        TextProfile_extra_About: 'Meu diferencial está na atenção aos detalhes, foco no usuário e cuidado com a experiência final do jogador.',
        Achievement_01_About: 'Bacharelado em Jogos Digitais - PUC Minas (2021 - 2024)',
        Achievement_02_About: 'Pós-Graduação em Engenharia de UX - PUC Minas (No Momento)',
        Achievement_03_About: 'Stellantis Education Award — Stellantis (2025)',

        Section_Experience: 'Experiência',

        // -- Experiencia 01 --
        Title_01_Experience: 'Desenvolvedora Unity Pleno',
        Company_01_Experience: 'Aioros Studios',
        Type_01_Experience: 'Tempo integral',
        Dates_01_Experience: 'abr de 2022 - o momento',
        Location_01_Experience: 'Belo Horizonte, Minas Gerais - Brasil',

        // -- Experiencia 02 --
        Title_02_Experience: 'Desenvolvedora de Jogos',
        Company_02_Experience: 'Minas Educa',
        Type_02_Experience: 'Estágio',
        Dates_02_Experience: 'ago de 2021 - mar de 2022',
        Location_02_Experience: 'Belo Horizonte, Minas Gerais - Brasil',

        // -- Experiencia 03 --
        Title_03_Experience: 'Analista em Suporte Técnico',
        Company_03_Experience: 'Construsite Brasil',
        Type_03_Experience: 'Tempo integral',
        Dates_03_Experience: 'abr de 2021 - set de 2021',
        Location_03_Experience: 'Belo Horizonte, Minas Gerais - Brasil',
       

        TitlePage_Contact: 'Contato',
        TitleForm_Contact: 'Entre em Contato',
        NameForm_Contact: 'Nome',
        SubjectForm_Contact: 'Assunto',
        EmailForm_Contact: 'Email',
        MessageForm_Contact: 'Mensagem',
        ButtonSendForm_Contact: 'Enviar',
        ResponseSendForm_Contact: 'Mensagem Enviada',
        NameLogoContact: 'Miius',
        TelephoneLogoContact: '+55 (31) 99330-3861',
        CopyEmailContact: 'Copiar Email',

        TitlePage_Footer: 'MIIUS',
        SubtitlePage_Footer: 'Gamer Developer',
        SocialPage_Footer: 'SOCIAL',
        Created_Footer: 'Desenvolvido por',

        TitlePage_ProjectsProfessional: 'Profissional',
        TitlePage_ProjectsPersonal: 'Pessoal',
        Game_Projects: 'Jogos',
        GameText_Projects: 'Clique no jogo para saber mais',
    },
    'en-US': {
        About_Header: 'About',
        Project_Header: 'Projects',
        Contact_Header: 'Contact',

        TextProfession_Intro: 'UNITY DEVELOPER · UX DESIGN',
        TextPresentation_Intro: 'Hello! I’m Marielle Fidelis',
        TextProfile_Intro: 'I’m a Unity Developer with 4+ years of experience creating games and interactive experiences for PC, mobile, and web. I work from prototype to final delivery, combining development, UX Design, and polish to create clearer, more responsive, and enjoyable interactions.',
        TextProfile_Intro_Extra: 'Currently working as a Mid-Level Unity Developer and pursuing a Postgraduate degree in UX Engineering. Want to know more? Check out my resume.',
        TextButtonCurriculum_Intro: 'Resume',

        Section_Project: 'Projects',
        Description_Hooked_Project: 'Responsible for:\n• UI/UX design and implementation\n• Wireframes and prototypes\n• UI animations and visual feedback\n• Project documentation',
        Description_Legaldigital_Project: 'Responsible for:\n• Full gameplay development\n• Minigames and board logic\n• Art implementation\n• Testing, polish, and release builds',
        Description_Blockar_Project: 'Responsible for:\n• UI/UX design and implementation\n• Wireframes and prototypes\n• Game feel and visual feedback\n• VFX and polish\n• System documentation',
        Button_View_Project: 'View More',

        Section_About: 'About Me',
       TextProfile_01_About: 'I hold a Bachelor’s Degree in Digital Games from PUC Minas and I’m currently pursuing a Postgraduate Degree in UX Engineering. Over more than 4 years of experience, I have contributed to 30+ projects for mobile, PC, and web, working across different stages of development, from prototyping to final polish. My work combines Unity, UX Design, and care for the user experience. I enjoy thinking about the details that make an interaction clearer and more pleasant, such as visual feedback, responsiveness, usability, game feel, and consistency. I also have experience with Game Design, Figma, and web development with HTML, CSS, and JavaScript.',
       TextProfile_extra_About: 'My main strength lies in my attention to detail, strong user focus, and dedication to delivering a polished final player experience.',
        Achievement_01_About: 'Bachelor\'s Degree in Digital Games - PUC Minas (2021 - 2024)',
        Achievement_02_About: 'Specialization in UX Engineering - PUC Minas (Present)',
        Achievement_03_About: 'Stellantis Education Award — Stellantis (2025)',

        Section_Experience: 'Experience',

        // -- Experience 01 --
        Title_01_Experience: 'Mid-level Unity Developer',
        Company_01_Experience: 'Aioros Studios',
        Type_01_Experience: 'Full-time',
        Dates_01_Experience: 'Apr 2022 - Present',
        Location_01_Experience: 'Belo Horizonte, Minas Gerais - Brazil',

        // -- Experience 02 --
        Title_02_Experience: 'Game Developer',
        Company_02_Experience: 'Minas Educa',
        Type_02_Experience: 'Internship',
        Dates_02_Experience: 'Aug 2021 - Mar 2022',
        Location_02_Experience: 'Belo Horizonte, Minas Gerais - Brazil',

        // -- Experience 03 --
        Title_03_Experience: 'Technical Support Analyst',
        Company_03_Experience: 'Construsite Brasil',
        Type_03_Experience: 'Full-time',
        Dates_03_Experience: 'Apr 2021 - Sep 2021',
        Location_03_Experience: 'Belo Horizonte, Minas Gerais - Brazil',
        
        TitlePage_Contact: 'Contact',
        TitleForm_Contact: 'Contact me',
        NameForm_Contact: 'Name',
        SubjectForm_Contact: 'Subject',
        EmailForm_Contact: 'Email',
        MessageForm_Contact: 'Message',
        ButtonSendForm_Contact: 'Send',
        ResponseSendForm_Contact: 'Message Sent',
        NameLogoContact: 'Miius',
        TelephoneLogoContact: '+55 (31) 99330-3861',
        CopyEmailContact: 'Copy Email',

        TitlePage_Footer: 'MIIUS',
        SubtitlePage_Footer: 'Game Developer',
        SocialPage_Footer: 'SOCIAL',
        Created_Footer: 'Developed by',

        TitlePage_ProjectsProfessional: 'Professional',
        TitlePage_ProjectsPersonal: 'Personal',
        Game_Projects: 'Games',
        GameText_Projects: 'Click on a game to learn more',
    },
};
  
export default i18nTexts;